/** The first non-empty `item[key]` as a string ('' when none); API objects use both snake_case and camelCase. */
export const getExternalId = (item, ...keys) => {
  for (const key of keys) {
    const value = item?.[key];
    if (value !== undefined && value !== null && value !== '') {
      return String(value);
    }
  }
  return '';
};
